import React, { useState } from "react";
import AuditDetailsView from "../../../../Models/Audit/AuditDetailsView";
import CreateAuditScheduleLocationProps from "../../../../Models/AuditProps/CreateAuditScheduleLocationProps";
import axios from "../../../../components/Api/Axios";
import BackendServices from "../../../../components/Api/BackendService";
import downloadCertificate from "../../http/downloadCertificate";
import downloadPDF from "../../http/downloadPDF";
import { VerifyUrls } from "../../index";
import {
  DropdownMenuItem,
  DropdownMenuItemType,
} from "../../../../components/DropdownMenu";
import Icon, { IconType } from "../../../../components/Icon";
import Permission from "../../../../Authentication/model/Permission";
import AuditStatus from "../../models/AuditStatus";
import VerifyAuditDetailsView from "../../../../Models/Verify/Models/VerifyAuditDetailsView";
import auditSharingPermission from "../../../../Enums/AuditSharingPermission";
import { dispatch } from "../../../../components/App/App";
import setError from "../../../../store/error/actions/setError";
import notifyRequestReportAccess from "../../http/notifyRequestReportAccess";
import { getUserId, isCompanyUser, isMegatronFeatureOn, isMegatronLiteUser, isMegatronProUser } from "../../../../Authentication/Auth";
import { trackEvent } from "../../../../util/googletagmanager/GTM";

export default (
  menuDetails: VerifyAuditDetailsView | undefined,
  refresh: () => void
): DropdownMenuItem[] => {
  if (!menuDetails) return [];
  return [
    getDownloadDocumentMenuItem(menuDetails),
    getNotifyReportMenuItem(menuDetails)
  ].filter((item) => item !== null) as DropdownMenuItem[];
};
    const megatronProUser = getUserId() != undefined &&  isMegatronProUser() ;
    const megatronLiteUser = getUserId() != undefined && isMegatronLiteUser();
const getDownloadDocumentMenuItem = (
  mainDetails: VerifyAuditDetailsView
): DropdownMenuItem | null => {
 
  if( mainDetails.sharingPermissionName ==  auditSharingPermission.CertificateOnly){    
   return{
    icon: <Icon type={IconType.DownloadPDF} />,
    type: DropdownMenuItemType.BUTTON,
    label: "Certificate Unavailable_"+ mainDetails.sharingPermissionName ,
    onClick: () => {      
     
    },
    permissionRequired: [{ permission: Permission.VIEW }],
  } 
}
if( mainDetails.sharingPermissionName ==  auditSharingPermission.CertificatePDF && mainDetails.certificationStatus.name != "Certificated"){    
  return{
   icon: <Icon type={IconType.DownloadPDF} />,
   type: DropdownMenuItemType.BUTTON,
   label: "Certificate Unavailable_"+ mainDetails.sharingPermissionName+"_"+mainDetails.certificationStatus.name,
   onClick: () => {      
    
   },
   permissionRequired: [{ permission: Permission.VIEW }],
 } 
}
if( mainDetails.sharingPermissionName ==  auditSharingPermission.CertificatePDF && mainDetails.certificationStatus.name == "Certificated" && mainDetails.hasCertificate==false){    
  return{
   icon: <Icon type={IconType.DownloadPDF} />,
   type: DropdownMenuItemType.BUTTON,
   label: "Certificate Unavailable_"+ mainDetails.sharingPermissionName +"_"+ mainDetails.certificationStatus.name ,
   onClick: () => {      
    
   },
   permissionRequired: [{ permission: Permission.VIEW }],
 } 
}

  return {
    

    icon: <Icon type={IconType.DownloadPDF} />,
    type: DropdownMenuItemType.BUTTON,
    label: "Download Certificate",
    onClick: () => {      
      if(mainDetails.hasCertificate)
      {
      downloadCertificate(mainDetails.id);
        if(megatronLiteUser || megatronProUser ){
           trackEvent('Feature_Interaction',{
            User_Role:megatronLiteUser?"Company user Lite":megatronProUser?"Company user Pro":"Other User",
            Tab_Section:"Certificate Tracker",
            Type:"Button",
            Feature_Function:"Download Certificate (Menu option)",
            UserInput:"Click"})
        }
      }
      else
      {
        dispatch(
          setError(
            "No certificate is currently available for this audit record"
          )
        );
      }
    },
    permissionRequired: [{ permission: Permission.VIEW }],
  };
};
  const isMegatronProUserCheck = getUserId() != undefined && isMegatronProUser() && isMegatronFeatureOn;
const getNotifyReportMenuItem = (
  mainDetails: VerifyAuditDetailsView
): DropdownMenuItem | null => {
 
   if( mainDetails.enableAuditReportNotification == true &&isMegatronProUserCheck){  
   return{
    icon: <Icon type={IconType.SHARE} />,
    type: DropdownMenuItemType.BUTTON,
     label:mainDetails.notificationStatus == "P"? "Report Access Pending": "Request Report Access",
    onClick:()=>mainDetails.notificationStatus == "P"? "":notifyRequestReportAccess(mainDetails.id),
    permissionRequired: [{ permission: Permission.VIEW }],
  } 
}
return null;

};
